import { Component, OnInit } from '@angular/core';
import { SafeHtml } from '@angular/platform-browser';
import * as AOS from 'aos';
import { SeoService } from '../Services/seo.service';
import { seoContent } from '../Services/seoContent';

@Component({
  selector: 'app-about-us',
  templateUrl: './about-us.component.html',
  styleUrls: ['./about-us.component.scss']
})
export class AboutUsComponent implements OnInit {

  logoDataHTML: SafeHtml;
  breadCrumbDataHTML: SafeHtml;

  projectCount = 0;
  accurateCount = 0;
  clientCount = 0;
  customerFeedback = 0;
  countries = 0;
  capabilitiesMenu = '01';
  OperatingMenu = '02';
  transformationMenu = '03';
  nextMenu = '04';
  AboutMenu = '05';
  spSoftMenu = '06';
  CareersMenu = '07';
  ContactMenu = '08';

  projectCountStop: any = setInterval(() => {
    this.projectCount++;
    if (this.projectCount === 29) {
      clearInterval(this.projectCountStop);
    }
  }, 50);

  accurateCountStop: any = setInterval(() => {
    this.accurateCount++;
    if (this.accurateCount === 100) {
      clearInterval(this.accurateCountStop);
    }
  }, 60);

  clientCountStop: any = setInterval(() => {
    this.clientCount++;
    if (this.clientCount === 650) {
      clearInterval(this.clientCountStop);
    }
  }, 55);

  customerFeedbackStop: any = setInterval(() => {
    this.customerFeedback++;
    if (this.customerFeedback === 500) {
      clearInterval(this.customerFeedbackStop);
    }
  }, 80);

  countriesCount: any = setInterval(() => {
    this.countries++;
    if (this.countries === 6) {
      clearInterval(this.countriesCount);
    }
  }, 6800);

  /**
   * Creates an instance of AboutUsComponent.
   * @param {SeoService} seoService
   */
  constructor(private seoService: SeoService) { }

  ngOnInit() {
    AOS.init();
    this.seoService.addTitleAndTags(seoContent.aboutUs.url, seoContent.aboutUs.title, seoContent.aboutUs.description);
    const servicesData = this.seoService.addStructuredData(seoContent.aboutUs.url, seoContent.aboutUs.title);
    this.logoDataHTML = servicesData.logoData;
    this.breadCrumbDataHTML = servicesData.breadData;
  }

}
